import { render } from "./OnlineLoginPage.vue?vue&type=template&id=07b2545f&scoped=true&ts=true"
import script from "./OnlineLoginPage.vue?vue&type=script&lang=ts"
export * from "./OnlineLoginPage.vue?vue&type=script&lang=ts"

import "./OnlineLoginPage.vue?vue&type=style&index=0&id=07b2545f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src93515913/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b2545f"]])

export default __exports__